export default {
  freePriceNote: "Gratuit uniquement lors de la commande de services payants",
  owner: {
    jobTitleMobileDev: 'Développeur d\'applications mobiles multiplateforme',
    jobTitleWebDev: 'Développeur web full stack',

    /* Services localizations */
    serviceFlutter: "Développement Flutter",
    serviceDescFlutter: "Je crée votre incroyable application mobile qui fonctionne sur Android et IOS, avec un design magnifique et des performances fluides. Ils seront séduits.",
    serviceBackend: "Développement back-end et API",
    serviceDescBackend: "Vous avez une application ou tout ce qui nécessite une API pour gérer les données générées par elle. Vous êtes au bon endroit.",
    serviceFrontend: "Développement front-end",
    serviceDescFrontend: "L'interface utilisateur est ce qui parle avec vos utilisateurs et clients. Optez pour ce service ce service pour avoir un front-end qui parle à vos utilisateurs et que je peux connecter à votre API existante si nécessaire.",
    serviceFirebase: "Intégration Firebase",
    serviceDescFirebase: "Une intégration complète de Firebase à votre site Web ou application mobile. En passant par le stockage de données, l'hébergement, les services crashlytics, jusqu'au cloud fonctions, etc.",
    serviceMobileMoney: "Paiement Orange et MTN Mobile Money",
    serviceDescMobileMoney: "Le Mobile Money vous permet de recevoir des paiements de ceux qui n'ont pas de compte bancaire. J'ajoute ces méthodes de paiement à votre application ou site web.",
    serviceMaps: "Intégration de cartes(Maps)",
    serviceDescMaps: "Suivi sur une carte, tracé d'itinéraire, alerte de positionnement, géolocalisation, suivi de positionnement en temps réel.",
    serviceSockets: "Intégration des \"push notification\" et du temps réel",
    serviceDescSockets: "Vous avez une application ou un site Web mais vous voulez que quelqu'un intègre un flux de données en temps réel, par exemple une fonctionnalité de chat ou tout autre. Ajoutez des \"push notifications\" pour notifier vos utilisateurs de quelque chose dans l'application. Vous êtes les bienvenus.",
    /* End Services localizations */

    thingBuildMobileApp: "Applications iOS et Android",
    thingBuildBackend: "Back-end d'application et api restful",
    thingBuildDesktop: "Applications de bureau",
    thingBuildWeb: "Applications Web",
    thingBuildLaravelDepTools: "Outils de déploiement Laravel",

    pricePlanItemSpecifications: "Faire le cahier de charges",
    pricePlanItemMilestones: "Conseil sur découpage des tâches",
    pricePlanItemMobile: "Développement application mobile",
    pricePlanItemBackend: "Développement backend / API",
    pricePlanItemFrontend: "Développement frontend",
    pricePlanItemWeb: "Développement site web",
    pricePlanItemDesktop: "Développement desktop",
  },
  labels: {
    french: "Français",
    english: "Anglais",
    downloadCv: "Télécharger mon CV",
    myServices: "Mes Services",
    yearsExperience: "Années d'expérience",
    doneProjects: "Projets achevés",
    happyCustomers: "Clients satisfaits",
    honorsAndAwards: "Distinctions honorifiques et récompenses",
    iBuild: "Je fais",
    pricePlans: "Prix tarifaires",
    startingFrom: "A partir de",
    free: "Gratuit",
    starterPlan: "Pack de démarrage",
    specificTasksPlan: "Pour tâches spécifiques",
    fullTimePlan: "Plein temps",
    githubRepo: "Voir le code sur github"
  },
  intros: {
    home: "Discouvrez comment <br/>Je vous aide à faire de votre <span style='text-decoration: line-through'>idée</span> Rêve une réalité!"
  }
}
